<template>
  <div class="modal fade" id="addStudentModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Student</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-left">
          <div v-if="availableOrganizations.length == 0">
            <h5>
              You do not have any groups to add a student to. Go to your
              organization and add a group to get started.
            </h5>
            <div class="col-auto">
              <button class="btn btn-primary" data-dismiss="modal">
                Close
              </button>
            </div>
          </div>
          <label v-if="errorMessage != ''" class="text-danger">{{
            errorMessage
          }}</label>
          <transition
            v-if="availableOrganizations.length > 0"
            name="slide-fade"
            mode="out-in"
          >
            <form v-if="page == 1" @submit.prevent="nextPage()" key="name">
              <div class="form-group">
                <label for="name"> Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  placeholder="Name"
                  v-model="newStudentName"
                  required
                />
              </div>
              <div class="form-group">
                <label for="grade">Grade</label>
                <select
                  id="grade"
                  name="gradePicker"
                  class="form-control selectpicker"
                  data-style="btn-outline-primary"
                  data-none-selected-text="Select Grade..."
                  data-actions-box="true"
                  v-model="newStudentGrade"
                  required
                >
                  <option
                    v-for="grade in Grades.slice().sort($orderByOrder)"
                    :key="grade.Grade_Id + 'grade'"
                    v-bind:value="grade"
                    >{{ grade.Title }}</option
                  >
                </select>
              </div>
              <label>Groups</label>
              <div
                v-for="organization in availableOrganizations
                  .slice()
                  .sort($orderByName)"
                :key="organization.Organization_Id + 'organization'"
                class="form-group form-check"
              >
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-bind:id="organization.Organization_Id"
                  v-bind:value="organization"
                  v-model="newStudentOrganizations"
                />
                <label
                  class="form-check-label"
                  v-bind:for="organization.Organization_Id"
                  >{{
                    Organizations.find(
                      o =>
                        o.Organization_Id == organization.Parent_Organization_Id
                    ).Name
                  }}
                  - {{ organization.Name }}</label
                >
              </div>
              <div class="text-right">
                <button type="submit" class="btn btn-primary">
                  Next
                </button>
              </div>
            </form>
            <form v-if="page == 2" @submit.prevent="nextPage" key="subjects">
              <div v-if="newStudentOrganizations.length > 0" class="form-group">
                <div
                  v-for="organization in newStudentOrganizations
                    .slice()
                    .sort($orderByName)"
                  :key="organization.Organization_Id + 'studentOrganization'"
                >
                  <label>{{ organization.Name }} Subjects</label>
                  <div v-if="organization.Subjects.length > 0">
                    <div
                      v-for="subject in organization.Subjects.slice().sort(
                        $orderByTitle
                      )"
                      :key="subject.Subject_Id + 'subject'"
                      class="form-group form-check"
                    >
                      <input
                        type="checkbox"
                        class="form-check-input"
                        v-bind:id="subject.Subject_Id"
                        v-bind:value="subject"
                        v-model="newStudentSubjects"
                      />
                      <label
                        class="form-check-label"
                        v-bind:for="subject.Subject_Id"
                        >{{ subject.Title }}</label
                      >
                    </div>
                  </div>
                  <p v-else>There are no subjects for this group.</p>
                </div>
              </div>
              <div class="row">
                <div class="col-auto">
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-on:click="previousPage"
                  >
                    Back
                  </button>
                </div>
                <div class="col" />
                <div class="col-auto">
                  <button type="submit" class="btn btn-primary">
                    Next
                  </button>
                </div>
              </div>
            </form>

            <form v-if="page == 3" @submit.prevent="nextPage" key="units">
              <div v-if="newStudentSubjects.length > 0" class="form-group">
                <div
                  v-for="subject in newStudentSubjects
                    .slice()
                    .sort($orderByTitle)"
                  :key="subject.Subject_Id + 'studentOrganization'"
                >
                  <label>{{ subject.Title }} Units</label>
                  <div v-if="subject.Units.length > 0">
                    <div
                      v-for="unit in subject.Units.slice().sort($orderByTitle)"
                      :key="unit.Unit_Id + 'subject'"
                      class="form-group form-check"
                    >
                      <input
                        type="checkbox"
                        class="form-check-input"
                        v-bind:id="unit.Unit_Id"
                        v-bind:value="unit"
                        v-model="newStudentUnits"
                      />
                      <label
                        class="form-check-label"
                        v-bind:for="unit.Unit_Id"
                        >{{ unit.Title }}</label
                      >
                    </div>
                  </div>
                  <p v-else>There are no units for this subject.</p>
                </div>
              </div>
              <div class="row">
                <div class="col-auto">
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-on:click="previousPage"
                  >
                    Back
                  </button>
                </div>
                <div class="col" />
                <div class="col-auto">
                  <button type="submit" class="btn btn-primary">
                    Next
                  </button>
                </div>
              </div>
            </form>

            <form
              v-if="page == 4"
              @submit.prevent="createStudent"
              key="managers"
            >
              <label>Student Manager(s) (Case Manager)</label>
              <div
                v-for="user in users.slice().sort($orderByLastName)"
                :key="user.User_Id + 'subject'"
                class="form-group form-check"
              >
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-bind:id="user.User_Id"
                  v-bind:value="user.User_Id"
                  v-model="newStudentManagers"
                />
                <label class="form-check-label" v-bind:for="user.User_Id"
                  >{{ user.First_Name }} {{ user.Last_Name }}</label
                >
              </div>
              <div class="row">
                <div class="col-auto">
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-on:click="previousPage"
                  >
                    Back
                  </button>
                </div>
                <div class="col" />
                <div class="col-auto">
                  <button type="submit" class="btn btn-primary">
                    Add Student
                  </button>
                </div>
              </div>
            </form>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "AddStudentModal",
  props: {
    Organizations: Array,
    Grades: Array
  },
  data() {
    return {
      newStudentName: "",
      availableOrganizations: [],
      newStudentOrganizations: [],
      newStudentSubjects: [],
      newStudentUnits: [],
      newStudentManagers: [],
      page: 1,
      newStudentGrade: null,
      users: [],
      errorMessage: ""
    };
  },
  watch: {
    Organizations: function() {
      this.availableOrganizations = this.Organizations.filter(
        o => o.Organization_Type_Id == 6 || o.Organization_Type_Id == 7
      );
      this.users = this.Organizations[0].Users;
    }
  },
  mounted() {
    $("#addStudentModal").on("shown.bs.modal", function() {
      $("#name").focus();
      $(".selectpicker").selectpicker("refresh");
    });
    $(".selectpicker").selectpicker("refresh");
  },
  methods: {
    async submitNewStudent() {
      await this.createStudent();
    },
    async createStudent() {
      $("#addStudentModal").modal("hide");
      var view = this;
      view.$store.commit("updateLoading", true);

      var studentToCreate = {
        Name: view.newStudentName,
        Grade: view.newStudentGrade
      };
      await view
        .$createStudent(studentToCreate)
        .then(async newStudent => {
          await view
            .createStudentOrganizations(newStudent.Student_Id)
            .then(async () => {
              await view
                .createStudentSubjects(newStudent.Student_Id)
                .then(async () => {
                  await view
                    .createStudentUnits(newStudent.Student_Id)
                    .then(async () => {
                      await this.$createUserPermissionsForStudent(
                        this.newStudentManagers,
                        newStudent.Student_Id,
                        8
                      ).then(async () => {
                        if (
                          view.newStudentManagers.includes(
                            view.$store.getters.user.User_Id
                          )
                        ) {
                          view.$store.getters.user.Permissions.push({
                            Permission_Id: 8,
                            Student_Id: newStudent.Student_Id
                          });
                        }
                        view.$store.commit("updateLoading", false);
                        view.$emit("student-added");
                        view.clearFields();
                      });
                    });
                });
            });
        })
        .catch(e => {
          console.log(e);
          $("#addStudentModal").modal("show");
          view.$store.commit("updateLoading", false);
        });
    },
    async createStudentOrganizations(newStudentId) {
      var view = this;
      if (view.newStudentOrganizations.length > 0) {
        return await view.$createStudentOrganizations(
          newStudentId,
          view.newStudentOrganizations.map(o => o.Organization_Id)
        );
      } else {
        return;
      }
    },
    async createStudentSubjects(newStudentId) {
      var view = this;
      if (view.newStudentSubjects.length > 0) {
        return await view.$createStudentSubjects(
          newStudentId,
          view.newStudentSubjects.map(s => parseInt(s.Subject_Id))
        );
      } else {
        return;
      }
    },
    async createStudentUnits(newStudentId) {
      var view = this;
      if (view.newStudentUnits.length > 0) {
        return await view.$createStudentUnits(
          newStudentId,
          view.newStudentUnits.map(u => parseInt(u.Unit_Id))
        );
      } else {
        return;
      }
    },
    nextPage() {
      switch (this.page) {
        case 1:
          if (this.newStudentOrganizations.length == 0) {
            this.errorMessage =
              "Please select at least one group for the new student.";
          } else {
            this.removeUnapplicableSubjects();
            this.page = 2;
            this.errorMessage = "";
          }
          break;
        case 2:
          this.removeUnapplicableUnits();
          if (this.newStudentSubjects.length == 0) {
            this.page = 4;
          } else {
            this.page = 3;
          }
          break;
        case 3:
          this.page = 4;
          break;
      }
    },
    previousPage() {
      this.page = this.page - 1;
      if (this.page == 1) {
        var CONTROL_INTERVAL = setInterval(function() {
          if ($("#grade").length > 0) {
            $("#grade").selectpicker("val", this.newStudentGrade);
            $(".selectpicker").selectpicker("refresh");
            clearInterval(CONTROL_INTERVAL);
          }
        }, 100);
      }
    },
    removeUnapplicableSubjects() {
      var organizationIds = this.newStudentOrganizations.map(
        o => o.Organization_Id
      );
      this.newStudentSubjects = this.newStudentSubjects.filter(s =>
        organizationIds.includes(s.Organization_Id.toString())
      );
    },
    removeUnapplicableUnits() {
      var subjectIds = this.newStudentSubjects.map(s => s.Subject_Id);
      this.newStudentUnits = this.newStudentUnits.filter(u =>
        subjectIds.includes(u.Subject_Id.toString())
      );
    },
    clearFields() {
      this.newStudentName = "";
      this.newStudentOrganizations = [];
      this.newStudentSubjects = [];
      this.newStudentUnits = [];
      this.page = 1;
      this.newStudentGrade = null;
      this.newStudentManagers = [];
    }
  }
};
</script>
